import { createStore } from "redux";
import rootReducer from "./reducers";

export default createStore(rootReducer);



// WEBPACK FOOTER //
// ./client/app/store.js